<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="500">
      <c-card class="white" title="계기판 거리 수정" v-if="odoDistanceData">
        <v-row>
          <v-col cols="12">기사 이름</v-col>
          <v-col cols="12" class="black--text ml-5">{{ odoDistanceData.driverName }}</v-col>
          <v-col cols="12">운행 시작 일시</v-col>
          <v-col cols="12" class="black--text ml-5">{{ $func.dateTimeToString(odoDistanceData.startTime) }}</v-col>
          <v-col cols="12">운행 종료 일시</v-col>
          <v-col cols="12" class="black--text ml-5">{{ $func.dateTimeToString(odoDistanceData.endTime)}}</v-col>
          <v-col cols="12">시작 계기판 거리 (km)</v-col>
          <v-col cols="12" class="ml-5 my-0 mr-10">
            <div style="width: 200px">
              <v-text-field class="ma-0" dense v-model="startDistance" :error="error"></v-text-field>
            </div>
          </v-col>
          <v-col cols="12">종료 계기판 거리 (km)</v-col>
          <v-col cols="12" class="ml-5 my-0 mr-0">
            <div style="width: 200px">
              <v-text-field dense v-model="endDistance" :error="error"></v-text-field>
            </div>
            <div v-show="error" class="red--text" style="font-size: 7px">시작 계기판 거리보다 종료 계기판 거리가 작습니다. 값을 다시 확인해주세요.</div>
          </v-col>
        </v-row>

        <div class="justify-center d-flex py-4">
          <c-btn class="mx-2" color="blue" outlined @click="reqUpdateOdoDistance">수정</c-btn>
          <c-btn class="mx-2" color="gray" outlined @click="openFlag = false">취소</c-btn>
        </div>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    odoDistanceData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      openFlag: false,
      startDistance: 0,
      endDistance: 0,

      error: false,
    }
  },
  watch: {
    open(value) {
      if (value && this.odoDistanceData) {
        this.openFlag = value;
        this.startDistance = this.odoDistanceData.startOdoDistance / 1000;
        this.endDistance = this.odoDistanceData.endOdoDistance / 1000;
        this.error = false;
      }
    },
    openFlag(value) {
      this.$emit('update:open', value);
    },
    startDistance(value) {
      this.error = this.endDistance < value;
    },
    endDistance(value) {
      this.error = this.startDistance > value;
    }
  },
  methods: {
    async reqUpdateOdoDistance() {
      const startDistance = Number(this.startDistance);
      const endDistance = Number(this.endDistance);
      if (!startDistance || !endDistance || startDistance > endDistance) {
        this.$store.commit('snackbar', {msg: '입력하신 값을 다시 확인해주세요.'});
        return;
      }

      try {
        const reqData = {
          id: this.odoDistanceData.id,
          startOdoDistance: startDistance * 1000,
          endOdoDistance: endDistance * 1000
        };

        await this.$api.updateObdDistanceLog(reqData);
        this.openFlag = false;
        this.$emit("reqOdoDistanceLog");
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqUpdateOdoDistance'});
      }
    }
  }

}
</script>

<style scoped>

</style>